import { toJpeg } from 'html-to-image';
import type { Options } from 'html-to-image/lib/types';

export const downloadScreenshot = async ({
  filename,
  screenshotRef,
  options,
}: {
  filename: string;
  screenshotRef: React.RefObject<HTMLDivElement>;
  options: Options;
}) => {
  if (screenshotRef.current === null) {
    return;
  }

  // TODO: Find proper solution to this horrible patch (dependency bug) https://github.com/bubkoo/html-to-image/issues/361
  // https://linear.app/sound/issue/ENG-4544/find-proper-solution-to-downloading-images-in-safari
  await toJpeg(screenshotRef.current, options);
  await toJpeg(screenshotRef.current, options);
  await toJpeg(screenshotRef.current, options);
  const dataUrl = await toJpeg(screenshotRef.current, options);

  const link = document.createElement('a');
  link.download = `${filename}.jpg`;
  link.href = dataUrl;
  link.click();
};
